import { Flex, Button, chakra } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import WithNavigationBarLayout from "src/components/WithNavigationBarLayout";
import { H2, BodyText } from "src/atoms/typography";
import getVideoSrc from "src/utils/getVideoSrc";

const Video = chakra("video");

export default function FirstNoMonitoringsView({ onClose, openDescription }) {
  const { t } = useTranslation();

  return (
    <WithNavigationBarLayout
      navigationBarProps={{
        headingKey: "activityLog.heading",
        onClose
      }}
    >
      <Flex flexDirection="column" alignItems="center" justifyContent="center" width="320px" mx="auto" height="100%">
        <Video
          loop
          borderRadius="16px"
          muted
          autoPlay
          playsInline
          src={getVideoSrc("al-showcase.mp4")}
          width="272"
          height="153"
        />
        <H2 color="highEmphasis" textAlign="center" mt="24px">
          {t("activityLog.noMonitorings.initial.heading")}
        </H2>
        <BodyText color="mediumEmphasis" textAlign="center" mt="6px">
          {t("activityLog.noMonitorings.text")}
        </BodyText>
        <Button variant="flatPrimary" onClick={openDescription} minWidth="196px" my="8px">
          {t("buttons.howItWorks")}
        </Button>
      </Flex>
    </WithNavigationBarLayout>
  );
}
